import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx } from 'react/jsx-runtime';
import { Caret } from '@box/blueprint-web-assets/icons/Fill';
import { Size2 } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './toolbar.module.js';
var ToolbarDropdownIndicator = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'down' : _ref$direction,
      className = _ref.className,
      color = _ref.color;
  return jsx(Caret, {
    ref: forwardedRef,
    className: clsx(_defineProperty({}, styles.invertCaret, direction === 'up'), styles.dropdownIndicator, className),
    color: color,
    height: Size2,
    role: "presentation",
    width: Size2
  });
});
export { ToolbarDropdownIndicator };